// extracted by mini-css-extract-plugin
module.exports = {"input":"InputPhone_input__9K2oT","textarea":"InputPhone_textarea__g7972","error":"InputPhone_error__uIMCP","test":"InputPhone_test__faxCS"};